import { Environment } from './environment.interface';

export const environment: Environment = {
    production: true,
    brand: 'santaschedule',
    // basePath: 'https://www.joblaundry-apigateway.com/apigateway',
    basePath: 'https://localhost:7222/apigateway',
    tocVersion: '1.0.1',
    firebase: {
        apiKey: "AIzaSyB-cDoeZcPaCw7qBwBKMLSzOXwdDR2ne28",
        authDomain: "map-the-day-staging.firebaseapp.com",
        projectId: "map-the-day-staging",
        storageBucket: "map-the-day-staging.firebasestorage.app",
        messagingSenderId: "280661850326",
        appId: "1:280661850326:web:e1ccfa3e22afab879e3177"
    }
};